<script>
  import  http  from "../api/http.js";
  import { Button, ButtonGroup,  Card, CardBody, CardHeader, Table  } from 'sveltestrap';
  import { onDestroy, onMount }  from 'svelte';
  import { selectedGroup, currentPage, groupHasSubbedVessels } from '../store.js';
  import Prettysize from 'prettysize';
  import CreateSoftwareModal from "../modals/CreateSoftwareModal.svelte";
  import DeleteVersionModal from "../modals/DeleteVersionModal.svelte";
  import DeleteSoftwareModal from "../modals/DeleteSoftwareModal.svelte";
  import EditSoftwareModal from "../modals/EditSoftwareModal.svelte";
  import EditVersionModal from "../modals/EditVersionModal.svelte";
  import ViewVersionModal from "../modals/ViewVersionModal.svelte";
  import Tooltip from '../reusable components/tooltip.svelte';
  import formatDate from "../Helpers/DateTimeFormatter.js";

  const privateSoftwareMode = 'private'
  const publicSoftwareMode = 'public'
  const managedSoftwareMode = 'managed';

  const softwareMode = 'package'
  const versionMode = 'version'

  let packages = [];
  let versions = [];
  let selectedSoftware = undefined;
  let softwareType = 'public';
  let displayName = '';
  let createSoftwareModal;
  let deleteVersionModal;
  let deleteSoftwareModal;
  let editSoftwareModal;
  let editVersionModal;
  let viewVersionModal;

  $:{
    $selectedGroup;
    softwareType = publicSoftwareMode;
  }

  $:{
    softwareType;
    $selectedGroup;
    packages = [];
    versions = [];
    selectedSoftware = undefined;
    loadPackages();
  }

  $:{
    if (selectedSoftware != undefined) {
      displayName = selectedSoftware.name;
      loadPackageVersions();
    }
  }
  
  async function loadPackages(){
    const requestedType = softwareType;
    const requestedGroup = $selectedGroup;
    const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/software/${requestedType}/${requestedGroup}`);
    if(res.status == 200 && softwareType === requestedType && $selectedGroup === requestedGroup){
      packages = await res.json();
      packages = packages;
      if(packages.length > 0){
        selectedSoftware = packages[0];
        displayName = selectedSoftware.name;
        await loadPackageVersions();
      }
      else{
        displayName = '';
      }
    }
  }

  async function loadPackageVersions(){
    const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/software/version/bysoftwareid/${selectedSoftware.id}/${$selectedGroup}`);
    if(res.status == 200){
      versions = await res.json();        
      versions = versions;
    }
  }

  function setStatusColor(status){
    let color = "info";
    switch(status){
      case "Failed":
        color = "danger";
        break;

      case "PendingBuild":
      case "Building":
        color = "info";
        break;
     
      case "Ready":
        color = "success";
        break;
    }
    return color;
  }

  const interval = setInterval(loadPackages, 30000);

  onMount(async () => {                            
    currentPage.set('packages');
    loadPackages();
  });

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<div class="d-flex">
  <h4 class="font-weight-bold text-primary mb-3 ">Packages</h4>
  {#if softwareType == privateSoftwareMode}
    <button class="btn btn-outline-primary ml-auto" on:click={() => createSoftwareModal.show(softwareMode, undefined)} disabled={softwareType == publicSoftwareMode || softwareType == managedSoftwareMode}>Create Software Package</button>
  {/if}
</div>
<p>Select a package to view associated versions.</p>
<div class="row">
  <div class="col-4">
    <Card style="min-height: 70vh;">
      <CardHeader>
      <div class="d-flex">
        <h5 class="mb-2 font-weight-bold mt-2">Packages</h5>
        <ButtonGroup class="ml-auto">
          <Button id="public-packages-button" color="primary" active={softwareType == 'public'} class="btnGrp" on:click={() => softwareType = publicSoftwareMode}>Public</Button>
          {#if $groupHasSubbedVessels == true}
            <Button id="managed-packages-button" color="primary" active={softwareType == 'managed'} class="btnGrp" on:click={() => softwareType = managedSoftwareMode} >Managed</Button>
            <Button id="private-packages-button" color="primary" active={softwareType == 'private'} class="btnGrp" on:click={() => softwareType = privateSoftwareMode} >Private</Button>             
          {/if}
        </ButtonGroup>
      </div>
    </CardHeader>
    <CardBody>
      {#if packages.length > 0}
        <Table resposive>
          <thead>
            <th>Name</th>
            <th>Created At</th>
            <th>Version Count</th>
            <th>Package Type</th>
            {#if softwareType == privateSoftwareMode}
              <th>Actions</th>
            {/if}
          </thead>
          <tbody>
            {#each packages as packageObject}
                <tr id="package-row{packageObject.name}{packageObject.id}-button" class="selector" on:mousedown={() => selectedSoftware = packageObject}>
                  <td>{packageObject.name}</td>
                  <td>{formatDate(packageObject.dateCreated)}</td>
                  <td><strong class="text-{packageObject.versionCount > 0 ? "info" : ""}">{packageObject.versionCount}</strong></td>
                  <td>{packageObject.packageType}</td>
                  {#if softwareType == 'private'}
                    <td>
                      <Button id="edit-package-{packageObject.id}-button" color="primary" class="btn-plus btn-icon-split btn-sm" alt="Edit" title="Edit" on:click={() => editSoftwareModal.show(packageObject)}>
                        <span class="icon text-white-50">
                          <i class="fas fa-pencil-alt"style="vertical-align:auto !important;"></i>
                        </span>
                      </Button> 
                      <Button id="delete-package-{packageObject.id}-button" color="primary" class="btn-plus btn-icon-split btn-sm" alt="Delete" title="Delete" on:click={() => deleteSoftwareModal.show(packageObject)}>
                        <span class="icon text-white-50">
                          <i class="fas fa-trash-alt"style="vertical-align:auto !important;"></i>
                        </span>
                    </Button> 
                    </td>
                  {/if}
                </tr>
            {/each}
          </tbody>
        </Table>
      {:else}
        No {softwareType} software packages to show.
      {/if}        
    </CardBody>
  </Card>
  </div>
<div class="col-8">
  <Card style="min-height: 70vh;">  
    <CardHeader>
      <div class="row">
        <div class="col-sm">
        <h5 class="mb-2 font-weight-bold mt-2"><span class="text-info">{displayName}</span> Package Versions</h5>
      </div>
      <div class="col-sm">
        {#if softwareType == privateSoftwareMode}
          <Button id="manage=software-button" color="primary" class="btn-plus btn-icon-split float-right ml-2" on:click={() => createSoftwareModal.show(versionMode, selectedSoftware)} disabled={softwareType == publicSoftwareMode || softwareType == managedSoftwareMode || packages.length == 0}>
            <span class="icon">
              <i class="fas fa-plus" style="vertical-align:auto !important;"></i>
            </span>
            <span class="text">
              Create Package Version          
            </span>
            </Button>
          {/if}
        </div>
      </div>
    </CardHeader>
    <CardBody>
      {#if versions.length > 0}
        <Table resposive>
          <thead>
            <th>Display Name</th>
              <th>Version</th>
              <th>Size</th>
              <th>Status</th>
              <th>Date Created</th>
              {#if softwareType == 'private'}
                <th>Actions</th>
              {/if}
          </thead>
          <tbody>
            {#each versions as version}
              <tr id="packageversion-row-{version.id}">
                <td>{version.displayName}</td>
                <td>
                  {#if version.versionNumber}
                    {version.versionNumber}
                  {:else}
                    Not Found
                  {/if}
                </td>                    
                <td>{Prettysize(version.size)}</td>
                <td>
                  <strong class="text-{setStatusColor(version.status)}">{version.status != null ? version.status:'Building'}</strong>
                  {#if version.status == 'Failed'}
                    <Tooltip title="Error Code" content={version.errorCode}><i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip>
                  {/if}
                </td>
                <td>{formatDate(version.dateCreated)}</td>
                <td>
                  {#if softwareType == 'private'}
                    <Button id="view-package-version-button-{version.id}" color="primary" class="btn-plus btn-icon-split btn-sm" alt="View" title="View Package Version" on:click={() => viewVersionModal.show(version)}>
                      <span class="icon text-white-50">
                        <i class="fa fa-eye"></i>
                      </span>
                    </Button> 
                    <Button id="edit-package-version-button" color="primary" class="btn-pencil btn-icon-split btn-sm" alt="Edit" title="Edit Package Version" disabled={version.status == "Building"} on:click={() => editVersionModal.show(version)}>
                      <span class="icon text-white-50">
                        <i class="fa fa-pencil"></i>
                      </span>
                    </Button>
                    <Button id="delete-package-version-button-{version.id}" color="primary" class="btn-plus btn-icon-split btn-sm" alt="Delete" title="Delete" on:click={() => deleteVersionModal.show(version)}>
                      <span class="icon text-white-50">
                        <i class="fas fa-trash-alt"></i>
                      </span>
                    </Button> 
                  {/if}
                </td>
              </tr>
              {/each}
          </tbody>
        </Table>
        {:else}
            No versions to show.
        {/if}
    </CardBody>
  </Card>
  </div>
</div>

<CreateSoftwareModal on:softwareCreated={() => loadPackages()} bind:this={createSoftwareModal}></CreateSoftwareModal>
<DeleteVersionModal on:versionDeleted={() => loadPackages()} bind:this={deleteVersionModal}></DeleteVersionModal>
<DeleteSoftwareModal on:softwareDeleted={() => loadPackages()} bind:this={deleteSoftwareModal}></DeleteSoftwareModal>
<EditSoftwareModal on:softwareEdited={() => loadPackages()} bind:this={editSoftwareModal}></EditSoftwareModal>
<EditVersionModal on:versionEdited={() => loadPackages()} bind:this={editVersionModal}></EditVersionModal>
<ViewVersionModal bind:this={viewVersionModal}></ViewVersionModal>

<style>
  .selector :hover{
    cursor: pointer;
    opacity: 1; 
    transition: 0.3s ease-in-out;
    color:#414249;
  }
</style>
